import {
	COMMUNICATION_FILTER,
	COMMUNICATION_FILTER_LABELS,
	type CommunicationFilterValue,
} from "@dune/types";
import { Toggle } from "@dune/ui";

const FILTER_VALUES = Object.values(COMMUNICATION_FILTER);

interface CommunicationFiltersProps {
	activeFilters: Set<CommunicationFilterValue>;
	onToggle: (filter: CommunicationFilterValue) => void;
}

export const CommunicationFilters = ({
	activeFilters,
	onToggle,
}: CommunicationFiltersProps) => {
	return (
		<div className="flex flex-wrap gap-2">
			{FILTER_VALUES.map((filter) => (
				<Toggle
					key={filter}
					variant="outline"
					size="sm"
					pressed={activeFilters.has(filter)}
					onPressedChange={() => onToggle(filter)}
					className="cursor-pointer data-[state=on]:bg-[#0096b5] data-[state=on]:text-white data-[state=on]:border-[#0096b5]"
				>
					{COMMUNICATION_FILTER_LABELS[filter]}
				</Toggle>
			))}
		</div>
	);
};
